<template>
  <div>
        <b-card
            no-body
            border-variant="msstream"
            class="marginal"
            v-if="$auth.validateRoles(['readConfigurations', 'modifyConfigurations'])"
        >
            <b-card-header
                    header-bg-variant="msstream"
                    header-text-variant="white"
                    class="text-center"
            >
                <h6 style="margin-bottom:0px">
                    <b-row class="align-items-center justify-content-center">
                        <b-icon icon="sliders"/>&nbsp;
                        {{$ml.get('rulesforconfig')}}&nbsp;
                        <span class="tag-configW">
                            <b-icon icon="key" class="ml-0" rotate="45" />
                            {{configuration.name}}
                        </span>
                    </b-row>
                </h6>
            </b-card-header>
            <b-card-body>
                <ConfigParamForm v-if="configurationID && !isSiteLoading" type="config" :config="configuration"></ConfigParamForm>
                <b-row v-if="!configurationID || isSiteLoading" class="justify-content-center">
                    <b-col cols="auto">
                        <b-spinner variant="primary" label="Spinning"></b-spinner>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>

        <b-card
            no-body
            border-variant="msstream"
            class="marginal"
            v-if="$auth.validateRoles(['readConfigurations', 'modifyConfigurations']) && $auth.getMyUser().client_infos[0].ecdn"
        >
            <b-card-header
                    header-bg-variant="msstream"
                    header-text-variant="white"
                    class="text-center"
            >
                <h6 style="margin-bottom:0px">
                    <b-icon icon="diagram3-fill" />
                    {{$ml.get('siteListConfig')}} 
                    <span class="tag-configW"> 
                        <b-icon icon="key" rotate="45" />
                        {{configuration.name}}
                    </span>
                </h6>
            </b-card-header>
            <b-card-body>
                <b-alert v-if="!authorized" variant="warning" show>{{$ml.get('readOnly')}}</b-alert>
                <b-row class="justify-content-center"><p style="font-size:small">{{$ml.get('siteexplainConfig')}}</p></b-row>
                <b-form-checkbox
                    size="sm"
                    id="otherP2Pcheck"
                    v-model="otherP2P"
                    name="otherP2P"
                    @change="pushOtherP2P"
                    class="otherP2P"
                    switch
                    :disabled="!authorized"
                    >
                    <b-icon v-if="otherP2P" icon="unlock-fill" />
                    <b-icon v-if="!otherP2P" icon="lock-fill" />&nbsp;{{$ml.get('acceptundeclaresite')}}
                </b-form-checkbox>
                <b-table bordered responsive style="font-size:small" striped hover :busy="isSiteLoading" :items="sites" :fields="fields" class="marginaltopsm">
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>{{$ml.get('loadingConfig')}}</strong>
                        </div>
                    </template>
                    <template #cell(Public_IPs)="row">
                        <span>[{{(row.item.publicIPs.join(', ').length > 50) ? row.item.publicIPs.join(', ').substring(0,50) + '...' : row.item.publicIPs.join(', ')}}]</span>
                    </template>
                    <template #cell(Subnets)="row">
                        <span>[{{(row.item.subNetworks.join(', ').length > 50) ? row.item.subNetworks.join(', ').substring(0,50) + '...' : row.item.subNetworks.join(', ')}}]</span>
                    </template>
                    
                    <template #cell(modif)="row">
                        <b-button size="sm" variant="msstreamblue " @click="analyticsSite(undefined, row.item)" v-if="$auth.validateRoles(['readAnalytics'])">
                            <b-icon icon="graph-up" />
                        </b-button> &nbsp;
                        <b-button size="sm" variant="mswarning" @click="modifySite(row.item)" :disabled="!authorized">
                            <b-icon icon="pencil-square" />
                        </b-button> &nbsp;
                        <b-button size="sm" variant="msstreamred" @click="removeSite(undefined, row.item)" :disabled="!authorized">
                            <b-icon icon="x" />
                        </b-button>
                        
                    </template>

                </b-table>
                <b-row class="justify-content-center">
                    <b-col cols="auto">
                        <b-btn size="sm" variant="msstreamblue" @click="addSite" :disabled="!authorized">
                            <b-icon icon="check2-square" />
                            {{$ml.get('addasite')}}
                        </b-btn>
                    </b-col>
                </b-row>
                <div v-if="isSiteFormActivated" class="marginaltop">
                    <hr>
                    <h6>{{$ml.get('entersiteinfo')}}</h6>
                    <b-form @submit.prevent="" style="font-size:small" >
                        <div>
                            <b-form-group
                                id="sitenameformlabel"
                                :label="$ml.get('namesite')"
                                label-for="sitenameform"
                                description=""
                            >
                                <b-form-input size="sm" id="sitenameform" v-model="modifiedSite.name" required :disabled="!authorized"></b-form-input>
                            </b-form-group>
                        </div>
                        <div>
                            <b-form-group
                                id="sitetypeformlabel"
                                :label="$ml.get('p2pconf')"
                                label-for="sitetypeform"
                                description=""
                                
                            >
                                <b-form-select size="sm" id="sitetypeform" v-model="modifiedSite.p2pType" :options="options" required :disabled="!authorized"></b-form-select>
                            </b-form-group>
                        </div>
                        <div class="marginaltop">
                            <b-form @submit.prevent="addPublicIP">
                                <b-form-group
                                    id="publicipsformlabel"
                                    :label="$ml.get('IPpub')"
                                    label-for="publicipsform"
                                    description=""
                                    
                                >
                                    <b-form-input size="sm" id="publicipsform" :state="publicIPValidation" v-model="newPublicIP" :disabled="!authorized"></b-form-input>
                                    <b-form-valid-feedback :state="publicIPValidation">
                                        {{$ml.get('validIPlist')}}
                                    </b-form-valid-feedback>
                                    <b-form-invalid-feedback :state="publicIPValidation">
                                        {{$ml.get('validIPCIDR')}}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-form>
                            <b-row v-if="modifiedSite.publicIPs && modifiedSite.publicIPs.length > 0" class="marginaltopsm">
                                <b-col style="margin-bottom: 20px;" cols="auto" v-for="(publicIP, idxPublicIP) in modifiedSite.publicIPs" v-bind:key="idxPublicIP">
                                    <small class="ip">{{publicIP}} <span class="ipremove" @click="removePublicIP(idxPublicIP)">X</span></small>
                                </b-col>
                            </b-row>
                        </div>
                        <div :class="{'marginaltop': modifiedSite.publicIPs.length === 0,'marginaltopsm': modifiedSite.publicIPs.length > 0}">

                            <b-form @submit.prevent="addSubnet">
                                <b-form-group
                                    id="subnetsformlabel"
                                    :label="$ml.get('subnets')"
                                    label-for="publicipsform"
                                    :description="$ml.get('subnetsinCIDR')"
                                >
                                    <b-form-input size="sm" id="subnetsform" :state="subnetValidation" v-model="newSubnet" :disabled="!authorized"></b-form-input>
                                    <b-form-valid-feedback :state="subnetValidation">
                                        {{$ml.get('validSublist')}}
                                    </b-form-valid-feedback>
                                    <b-form-invalid-feedback :state="subnetValidation">
                                        {{$ml.get('validSublistCIDR')}}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-form>
                            <b-row v-if="modifiedSite.subNetworks && modifiedSite.subNetworks.length > 0" class="marginaltopsm">
                                <b-col style="margin-bottom: 20px;" cols="auto" v-for="(subNetwork, idxSubNetwork) in modifiedSite.subNetworks" v-bind:key="idxSubNetwork">
                                    <small class="ip">{{subNetwork}} <span class="ipremove" @click="removeSubnet(idxSubNetwork)">X</span></small>
                                </b-col>
                            </b-row>
                        </div>
                        
                        <b-row class="justify-content-end marginaltopsm">
                            <b-col cols="auto">
                                <b-btn variant="msstreamblue" @click="pushSite" :disabled="!authorized">
                                    <b-icon icon="check2-circle" />
                                    {{$ml.get('save')}}
                                </b-btn>
                            </b-col>
                            <b-col cols="auto">
                                <b-button variant="mswarning" @click="isSiteFormActivated=false">
                                <b-icon icon="arrow-counterclockwise" />
                                {{$ml.get('cancel')}}
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </div>
            </b-card-body>
                </b-card>

                <CopiedModal ref="copied"></CopiedModal>
        </div>
</template>

<script>
import {v4 as uuidv4} from 'uuid';
import ConfigParamForm from '@/components/ConfigParamForm.vue';
import CopiedModal from '@/components/modals/CopiedModal.vue';
import ConfigurationService from '@/services/configuration.service.js';
import SamplePage from '@/views/SamplePage.vue';
//import Roles from '@/components/Roles.vue';
let configurationService = new ConfigurationService();


export default {
  name: 'configurationsite',
  props: [
    "uuid"
  ],
  components: {
    CopiedModal,
    ConfigParamForm,
    //Roles
  },
  watch: {
    uuid: function(newUuid) {
        this.uuid = newUuid;
        this.getSites();
    }
  },
  data() {
    return {
        authorized: this.$auth.validateRoles(['modifyConfigurations']),
        isSiteLoading: false,
        configurationID: null,
        otherP2P: false,
        configuration: {},
        sites: [],
        isSiteFormActivated: false,
        modificationIndex: -1,
        modifiedSite: {

        },
        newPublicIP: '',
        newSubnet: ''

    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'name',
          label: this.$ml.get('nameField'),
          tdClass: 'align-middle',
          sortable: true
        },
        {
          key: 'Public_IPs',
          tdClass: 'align-middle',
          label: this.$ml.get('publicIPsField')
        },
        {
          key: 'Subnets',
          tdClass: 'align-middle',
        },
        {
          key: 'p2pType',
          label: this.$ml.get('p2pActivatedField'),
          tdClass: 'align-middle',
          sortable: true
        },
        {
          key: 'updatedAt',
          label: this.$ml.get('lastUpdatedField'),
          tdClass: 'align-middle',
          sortable: true
        },
        {
          key: 'modif',
          sortable: false,
          tdClass: 'align-middle, text-center',
          label: ''
        },
      ];
    },
    options() {
      return [
        { value: "strict_subnet", text: this.$ml.get('p2pStrictSubnet') },
        { value: "subnet", text: this.$ml.get('p2pSubnet') },
        { value: "intrasite", text: this.$ml.get('p2pIntrasite') },
        { value: "off", text: this.$ml.get('p2pOff') },
      ];
    },
    publicIPValidation() {
        if (this.newPublicIP === "") {
            return null;
        } else {
            return (this.newPublicIP.match(/^([0-9]{1,3}\.){3}[0-9]{1,3}(\/([0-9]|[1-2][0-9]|3[0-2]))?$/g) !== null)
        } 
    },
    subnetValidation() {
        if (this.newSubnet === "") {
            return null;
        } else {
            return (this.newSubnet.match(/^([0-9]{1,3}\.){3}[0-9]{1,3}(\/([0-9]|[1-2][0-9]|3[0-2]))$/g) !== null)
        } 
    }
  },
  mounted() {
    this.getSites();
  },
  methods: {
    getSites() {
        this.isSiteLoading = true
        configurationService.getConfiguration(this.uuid, this.$auth.token()).then(configuration => {
            this.sites = configuration.sites;
            this.configurationID = configuration.uuid;
            this.otherP2P =  configuration.otherP2P || false;
            this.configuration = configuration;
            this.$emit('configuration-loaded', configuration);
            this.isSiteLoading = false;
        }).catch(err => {
            //TODO show modal error
            this.isSiteLoading = false;
        })
    },
    resetSites() {
        
    },
    addPublicIP() {
        if (this.modifiedSite.publicIPs.indexOf(this.newPublicIP) === -1) {
            this.modifiedSite.publicIPs.push(this.newPublicIP);
            this.newPublicIP = "";
        }
    },
    removePublicIP(idx) {
        this.modifiedSite.publicIPs.splice(idx, 1);
        this.modifiedSite.publicIPs = this.modifiedSite.publicIPs.splice(0);
    },
    addSubnet() {
        if (this.modifiedSite.subNetworks.indexOf(this.newSubnet) === -1) {
            this.modifiedSite.subNetworks.push(this.newSubnet);
            this.newSubnet = "";
        }
    },
    removeSubnet(idx) {
        this.modifiedSite.subNetworks.splice(idx, 1);
        this.modifiedSite.subNetworks = this.modifiedSite.subNetworks.splice(0);
    },
    addSite() {
        this.modifiedSite = {
            name: "Site " + (this.sites.length+1),
            uuid: uuidv4(),
            p2pType: "strict_subnet",
            subNetworks: [],
            publicIPs: []
        }
        this.modificationIndex = -1;
        this.isSiteFormActivated = true;
    },
    modifySite(site, idx) {
        this.modifiedSite = JSON.parse(JSON.stringify(site));
        if (idx === undefined) {idx = this.sites.indexOf(site)}
        this.modificationIndex = idx;
        this.isSiteFormActivated = true;
    },
    removeSite(idx, site) {
        if (idx === undefined) {idx = this.sites.indexOf(site)}
        this.sites.splice(idx, 1);
        this.sites = this.sites.splice(0)
        configurationService.putConfiguration(this.configurationID, {sites: this.sites}, this.$auth.token()).then(() => {
            this.getSites();
        }).catch(err => {
            // TODO showModal Error
        })
    },
    analyticsSite(idx, site) {
        if(idx === undefined) {idx = this.sites.indexOf(site)}
        let filter = this.configuration.uuid + "_" + this.sites[idx].uuid

        this.$router.push('/analytics?site=' + encodeURIComponent(this.sites[idx].name) + '&filter=' + encodeURIComponent(filter));
    },
    analyticsSiteGlobal() {
        this.$router.push('/analytics?config=' + encodeURIComponent(this.configuration.name) + '&key=' + encodeURIComponent(this.configuration.key)+"&title=configuration");
    },
    pushSite() {
        this.modifiedSite.updatedAt = new Date().toISOString();
        if (this.modificationIndex === -1) {
            this.sites.push(this.modifiedSite);
        } else {
            this.sites[this.modificationIndex] = JSON.parse(JSON.stringify(this.modifiedSite));
            this.sites = this.sites.splice(0);
        }
         configurationService.putConfiguration(this.configurationID, {sites: this.sites}, this.$auth.token()).then(() => {
                this.addSite();
                this.isSiteFormActivated = false;
                this.getSites();
            }).catch(err => {
                // TODO showModal Error
            })
        
    },
    pushOtherP2P() {
        this.modifiedSite.updatedAt = new Date().toISOString();
         configurationService.putConfiguration(this.configurationID, {otherP2P: this.otherP2P}, this.$auth.token()).then(() => {
                this.configuration.otherP2P = this.otherP2P;
            }).catch(err => {
                // TODO showModal Error
                this.otherP2P = this.configuration.otherP2P;
            })
        
    },
    pushRules() {
        this.modifiedSite.updatedAt = new Date().toISOString();
         configurationService.putConfiguration(this.configurationID, {rules: this.rules}, this.$auth.token()).then(() => {
                this.configuration.rules = this.rules;
            }).catch(err => {
                // TODO showModal Error
                this.rules = this.configuration.rules;
            })
    }

  }


}
</script>

<style scoped lang="scss">
.otherP2P {
    border-top: solid 1px rgba(47,144,176,1);
    padding-top: 15px;
    border-bottom: solid 1px rgba(47,144,176,1);
    padding-bottom: 15px;
    background-color: rgba(47,144,176,0.2);

    padding-left: 3rem;
}
.custom-select {
    color: #2a5d77 !important;
    border-color: #2a5d77 !important;
    cursor: pointer;
}
.custom-select:hover {
    color: #048F94 !important;
}

.ip {
    background-color: rgba(47,144,176,1);
    border-radius: 5px;
    color: white;
    padding: 5px;  
}
.ipremove {
    cursor: pointer;
    margin-left: 15px;
    font-weight: 500;
    &:hover {
        color:#ba0000;
    }
}


</style>
